/* Burnt End Boards. One job: the add-on checkbox on the product page.
   Wood and metal chips are Dawn's own radio inputs, so Dawn's variant-selects
   handles those with no help from here.

   Dawn 16 re-renders <product-info> server side on a variant change, which
   replaces the checkbox node. Everything below is delegated from document so it
   keeps working after a re-render, and the checked state is carried across. */
(function () {
  'use strict';

  var addonChecked = false;

  document.addEventListener('change', function (event) {
    var box = event.target.closest ? event.target.closest('[data-beb-addon]') : null;
    if (box) addonChecked = box.checked;
  });

  // Re-apply the remembered state after Dawn swaps the product info markup.
  document.addEventListener('product-info:loaded', restore);
  if (window.subscribe && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      window.setTimeout(restore, 0);
    });
  }

  function restore() {
    var box = document.querySelector('[data-beb-addon]');
    if (box) box.checked = addonChecked;
  }




  /* ---- gallery thumbnails ----
     Clicking a thumb swaps the main image. Delegated from document so it keeps
     working after Dawn re-renders product-info or beb.js swaps the gallery. */
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest ? event.target.closest('.beb-gallery__thumb') : null;
    if (!thumb) return;

    var gallery = thumb.closest('.beb-gallery');
    var main = gallery && gallery.querySelector('.beb-gallery__main img');
    if (!main) return;

    main.src = thumb.dataset.full;
    main.srcset = thumb.dataset.srcset || '';
    main.alt = thumb.dataset.alt || '';
    if (thumb.dataset.w) main.width = thumb.dataset.w;
    if (thumb.dataset.h) main.height = thumb.dataset.h;
    main.loading = 'eager';

    gallery.querySelectorAll('.beb-gallery__thumb').forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  });

  /* ---- mobile menu drawer ----
     Dawn's HeaderDrawer.openMenuDrawer() throws on a null reference in this
     header (it reaches for markup the stock header renders and this one does
     not), so the drawer never receives the .menu-opening class its own CSS uses
     to slide in. Rather than fork Dawn's header markup wholesale, drive that one
     class here. Dawn's own CSS still does the animation, and its Escape and
     focusout handlers still close the drawer. */
  document.addEventListener('click', function (event) {
    var summary = event.target.closest ? event.target.closest('header-drawer > details > summary') : null;
    if (!summary) return;

    var details = summary.parentNode;
    var wasOpen = details.hasAttribute('open');

    // <details> toggles itself after this handler, so invert the state we saw.
    window.setTimeout(function () {
      if (wasOpen) {
        details.classList.remove('menu-opening');
        summary.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-mobile');
      } else {
        details.classList.add('menu-opening');
        summary.setAttribute('aria-expanded', 'true');
        document.body.classList.add('overflow-hidden-tablet');
        var focusable = details.querySelector('.menu-drawer a, .menu-drawer button');
        if (focusable) focusable.focus();
      }
    }, 0);
  });

  // Escape closes it, matching Dawn's behaviour.
  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('header-drawer > details[open].menu-opening');
    if (!open) return;
    open.removeAttribute('open');
    open.classList.remove('menu-opening');
    document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-mobile');
    var summary = open.querySelector('summary');
    if (summary) { summary.setAttribute('aria-expanded', 'false'); summary.focus(); }
  });

  /* ---- gallery swap on variant change ----
     Dawn's product-info fetches the section HTML for the new variant and calls
     updateMedia(), which only knows about its own <media-gallery>. The stacked
     gallery here is ours, so Dawn leaves it showing the previous wood.

     Request the same section markup Dawn requests, keyed on option_values,
     which is readable straight off the checked radios. Reading ?variant= from
     the URL instead would race Dawn's own history update and fetch the old
     variant. product-info replaces the variant-selects node wholesale, so this
     is delegated from document rather than bound to a node that gets replaced. */
  var galleryRequest = 0;

  document.addEventListener('change', function (event) {
    var selects = event.target.closest ? event.target.closest('variant-selects') : null;
    if (!selects) return;

    var info = selects.closest('product-info');
    if (!info || !info.querySelector('.beb-gallery')) return;

    var values = Array.prototype.map.call(
      selects.querySelectorAll('select option[selected], fieldset input:checked'),
      function (node) { return node.dataset.optionValueId; }
    ).filter(Boolean);
    if (!values.length) return;

    var token = ++galleryRequest;
    var url =
      (info.dataset.url || window.location.pathname) +
      '?section_id=' + encodeURIComponent(info.dataset.section) +
      '&option_values=' + values.join(',');

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        if (token !== galleryRequest) return; // a newer switch already won
        var next = new DOMParser().parseFromString(text, 'text/html').querySelector('.beb-gallery');
        var current = info.querySelector('.beb-gallery');
        if (next && current) current.replaceWith(next);
      })
      .catch(function (e) { console.error(e); });
  });

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;

      var productForm = form.closest('product-form');
      var box = productForm ? productForm.parentElement.querySelector('[data-beb-addon]') : null;
      if (!box) box = document.querySelector('[data-beb-addon]');
      if (!box || !box.checked) return; // let Dawn handle the normal single-item add

      var addonId = box.getAttribute('data-addon-variant');
      var mainId = form.querySelector('[name="id"]');
      if (!addonId || !mainId || !mainId.value) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var cart =
        document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var submit = form.querySelector('[type="submit"]');
      var spinner = form.querySelector('.loading__spinner');

      if (submit) {
        submit.setAttribute('aria-disabled', 'true');
        submit.classList.add('loading');
      }
      if (spinner) spinner.classList.remove('hidden');

      var quantityField = form.querySelector('[name="quantity"]');
      var quantity = parseInt(quantityField && quantityField.value, 10) || 1;

      var body = {
        items: [
          { id: Number(mainId.value), quantity: quantity },
          { id: Number(addonId), quantity: 1 }
        ]
      };

      if (cart && cart.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map(function (s) {
          return s.id;
        });
        body.sections_url = window.location.pathname;
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
      }

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response.status) {
            var wrapper = form
              .closest('product-form')
              .querySelector('.product-form__error-message-wrapper');
            if (wrapper) {
              wrapper.removeAttribute('hidden');
              var msg = wrapper.querySelector('.product-form__error-message');
              if (msg) msg.textContent = response.description || response.message;
            }
            return;
          }

          if (window.publish && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'beb-addon',
              productVariantId: mainId.value,
              cartData: response
            });
          }

          if (cart) {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(response);
          } else {
            window.location = window.routes.cart_url;
          }
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(function () {
          if (submit) {
            submit.classList.remove('loading');
            submit.removeAttribute('aria-disabled');
          }
          if (spinner) spinner.classList.add('hidden');
        });
    },
    true // capture, so this runs before Dawn's own submit listener
  );
})();
